// extracted by mini-css-extract-plugin
export default {"icon":"FileInfo-icon_V45Zt"};